/** Company legal footer — aligned with marketing site and transactional emails. */
export const COMPANY_LEGAL = {
  name: 'Coordal Technologies Ltd.',
  address: 'Michel Camp Barracks Road, Mataheko-Afienya, Accra, Ghana',
  gpsCode: 'GN-1251-0218',
  registrationNumber: 'CS110510526',
} as const;
